<!-- licencias.component.html -->
<app-breadcrumb [title]="'Empresas Activas'" [items]="['Empresarial']"
  [active_item]="'Empresas Activas'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
 <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-briefcase-alt-1 me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE EMPRESAS INACTIVAS</strong></h5>
    </div>

    <div class="card-body custom-datatable noscroll">
      <div class="row mb-12">
        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar....."
              [(ngModel)]="searchText"
              (input)="filterData()"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
            </span>
          </div>
        </div>
      </div>
      <div class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered" id="tblEmpresasInactivas">
          <thead>
           
              <tr class="bg-primary">
                <th class="text-center text-white" (click)="sortData('nit')" style="cursor: pointer;">
                  <strong>NIT</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'nit' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'nit' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'nit'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('digito')" style="cursor: pointer;">
                  <strong>DIGITO</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'digito' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'digito' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'digito'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('nombre')" style="cursor: pointer;">
                  <strong>EMPRESA</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'nombre' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'nombre'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('tipo')" style="cursor: pointer;">
                <strong>TIPO EMPRESA</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'tipo' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'tipo' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'tipo'
              }"></i>
              </th>
                <th class="text-center text-white" (click)="sortData('direccion')" style="cursor: pointer;">
                  <strong>DIRECCIÓN</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'direccion' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'direccion' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'direccion'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('telefono')" style="cursor: pointer;">
                  <strong>TELÉFONO</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'telefono' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'telefono' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'telefono'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('celular')" style="cursor: pointer;">
                  <strong>CELULAR</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'celular' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'celular' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'celular'
                  }"></i>
                </th>
                <th class="text-center text-white" (click)="sortData('email')" style="cursor: pointer;">
                  <strong>EMAIL</strong>
                  <i class="fa ms-1" [ngClass]="{
                    'fa-sort-up': sortColumn === 'email' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'email' && sortDirection === 'desc',
                    'fa-sort': sortColumn !== 'email'
                  }"></i>
                </th>
                <th class="text-center text-white"><strong>OPCIONES</strong></th>
              </tr>
            
            
          </thead>

          <tbody>
            <tr *ngFor="
                let empresa of empresas of filteredTableItems
                  | paginate : { itemsPerPage: pageSize, currentPage: page };
                let i = index
              ">
              <td class="text-center">{{ empresa.nit }}</td>
              <td class="text-center">{{ empresa.digito }}</td>
              <td class="text-uppercase text-justify">{{ empresa.nombre }}</td>
               <td class="text-uppercase text-justify">
                <ng-container *ngFor="let cat of empresa.categorias">
                  <span *ngIf="cat" class="badge me-1" [ngClass]="cat.class">
                    &bull; {{ cat.text }}
                  </span>
                </ng-container>
              </td>
              <td class="text-uppercase text-justify">
                {{ empresa.direccion }}
              </td>
              <td class="text-center">{{ empresa.telefono }}</td>
              <td class="text-center">{{ empresa.celular }}</td>
              <td class="text-center">{{ empresa.email }}</td>
              <td>
                <div class="text-center">
                  <ul class="list-inline">
                    <li class="text-center text-primary fw-bold" (click)="activarempresa(empresa.nit)">
                      <a href="javascript:void(0)" class="text-primary"  ngbTooltip="Activar Empresa">
                        <i class="icon-check-box"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <!-- Selector de registros por página alineado a la izquierda -->
          <div class="d-flex align-items-center">
            <label for="pageSize" class="me-2">Mostrar:</label>
            <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                {{ size }}
              </option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>

          <!-- Mostrar cantidad total de registros centrado -->
          <div class="text-center flex-grow-1">
            Total Registros:
            <a class="badge badge-primary"><b>{{ filteredTableItems?.length }}</b></a>
          </div>

          <!-- Paginador alineado a la derecha -->
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
              previousLabel="Anterior" nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
            (click)="exportarExcel('tblEmpresasInactivas', 'Listado_Empresas_Inactivas')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
              exportToPDF(
                'tblEmpresasInactivas',
                'Listado_Empresas_Inactivas',
                'Listado de Empresas'
              )
            ">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>